var render = function (_h,_vm) {var _c=_vm._c;return _c('h1',{class:[
    _vm.$style.title,
    _vm.props.bold && _vm.$style.bold,
    _vm.props.strong && _vm.$style.strong,
    _vm.props.heading && _vm.$style.heading,
    _vm.data.staticClass ],style:(_vm.data.staticStyle)},[_vm._t("default"),(_vm.slots().legend)?_c('div',{class:_vm.$style.legend},[_vm._t("legend")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }